import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MenuListContainerModel } from '../../../../../../models/aggregates/cms/menu';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class MenuListService extends BaseApiPublicLoginTemplateService<MenuListContainerModel, MenuListContainerModel, MenuListContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'menu-lists';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'menu-lists';
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'menu-lists/' + BaseApiTemplateService.PUBLIC_EP;
  }
}
